import { EventBus } from '@/store/eventBus';
import axios from 'axios';
import ItemIndex from '@/views/Admin/Config/Commonn/ItemIndex';
import ItemIndexFilterNotification from '@/views/Admin/Config/Commonn/ItemIndexFilterNotification';

const ItemIndexBoilerplate = {
    components: { ItemIndex, ItemIndexFilterNotification },
    data() {
        return {
            searchTerm: '',
            items: [],
            filter: {
                show: false,
                type: '',
                term: '',
            },
            tableLoading: false,
        };
    },

    mounted() {
        const ls = localStorage.getItem(this.indexType+'IndexFilter');
        if (ls && ls !== '') {
            const storage = JSON.parse(ls);
            this.getIndexDataFiltered(storage.type, storage.term, storage.id);
        } else {
            this.getIndexDataAll();
        }

        EventBus.$on('IndexSearchTerm', (term) => this.searchTerm = term);
        EventBus.$on(`${this.indexType}+ClearIndexFilter`, () => this.clearFilter());
    },

    methods: {
        setFilter(type, term, id) {
            this.filter.type = type;
            this.filter.term = term;
            this.filter.show = true;
            localStorage.setItem(this.indexType + 'IndexFilter', JSON.stringify({'type': type, 'term': term, 'id': id}));
        },

        clearFilter() {
            this.filter.show = false,
            this.filter.type = '';
            this.filter.term = '';

            const ls = localStorage.getItem(this.indexType + 'IndexFilter');
            if (ls) {
                localStorage.removeItem(this.indexType + 'IndexFilter');
            }

            EventBus.$emit('ClearIndexSearch');
            this.getIndexDataAll();
        },

        getIndexDataAll() {
            this.tableLoading = true;
            this.items = []; // Clear existing items.
            axios.get('/api/' + this.indexType + '/index')
                .then((response) => {
                    this.items = response.data.data[this.responseObject];
                    this.tableLoading = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.tableLoading = false;
                });
        },

        filterIndex(type, item) {
            let term = '';
            let id = '';

            if (type === 'Step') {
                if (item.card) {
                    term = item.card.section.step.name;
                    id = item.card.section.step.id;
                } else if (item.section) {
                    term = item.section.step.name;
                    id = item.section.step.id;
                } else if (item.step) {
                    term = item.step.name;
                    id = item.step.id;
                }
            }

            if (type === 'Section') {
                if (item.card) {
                    term = item.card.section.step.name + '\\' + item.card.section.name;
                    id = item.card.section.id;
                } else if (item.section) {
                    term = item.section.step.name + '\\' + item.section.name;
                    id = item.section.id;
                }
            }

            if (type === 'Card') {
                if (item.card) {
                    if (item.card.section) {
                        term = item.card.section.step.name + '\\' + item.card.section.name + '\\' + item.card.name;
                        id = item.card.id;
                    } else if (item.card.page) {
                        term = item.card.page.name + '\\' + item.card.name;
                        id = item.card.id;
                    }
                } else if (item.section) {
                    if (item.section) {
                        term = item.section.step.name + '\\' + item.section.name + '\\' + item.name;
                        id = item.id;
                    } else if (item.page) {
                        term = item.page.name + '\\' + item.name;
                        id = item.id;
                    }
                }
            }

            if (type === 'Page') {
                if (item.card) {
                    term = item.card.page.name;
                    id = item.card.page.id;
                } else if (item.page) {
                    term = item.page.name;
                    id = item.page.id;
                }
            }

            this.getIndexDataFiltered(type, term, id);
        },

        getIndexDataFiltered(type, term, id) {
            this.setFilter(type, term, id);
            this.tableLoading = true;
            EventBus.$emit('ClearSearch'); // Filtering clears text search.
            this.items = []; // Clear existing items.

            axios.get('/api/' + this.indexType + '/index/'+type+'/'+id)
                .then((response) => {
                    this.items = response.data.data[this.responseObject];
                    this.tableLoading = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.tableLoading = false;
                });
        }
    }
};

export default ItemIndexBoilerplate;
